export default __webpack_public_path__ + "static/media/My project (83) 2 (3).709bcfcd.png";